module.exports = __webpack_public_path__ + "img/307.2e2d6296.png";